import React, { useEffect, useState } from "react";

const AppContext = React.createContext();

const AppProvider = ({ children }) => {
  const [loadingApp, setLoadingApp] = useState(true);
  //const [token, setToken] = useState(null);
  const [token, setToken] = useState(localStorage.getItem(process.env.REACT_APP_API_AUTH_TOKEN));
  //const [user, setUser] = useState(null);
  const [currentUser, setUser] = useState({currentUser:""});

  return (
    <AppContext.Provider
      value={{
        loadingApp,
        setLoadingApp,
        currentUser,
        setUser,
        token,
        setToken,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export { AppContext, AppProvider };
